import './Login.css';
import { useState, useContext, createContext } from 'react';
import { Card, Button, Checkbox, Form, Input, Space, message, Carousel, ConfigProvider } from "antd";
import { Link } from 'react-router';

import { LeftCircleOutlined, LeftOutlined } from '@ant-design/icons';

const MessageApiContext = createContext();

async function signUpReq(values) {
  const resp = await fetch("/api/auth/email/signup", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(values),
  });
  return await resp.json();
}

async function loginReq(values) {
  const resp = await fetch("/api/auth/email/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(values),
  });
  return await resp.json();
}

function Login() {
  const [formDisabled, setDisabled] = useState(false);
  const messageApi = useContext(MessageApiContext);

  const loginAccount = async (values) => {
    setDisabled(true); // Disable the form to prevent multiple submissions
    messageApi.open({
      type: 'loading',
      content: 'Logging in...',
      duration: 0,
    });

    console.log("Login values:", values);

    // Send the login request
    try {
      const response = await loginReq(values);
      messageApi.destroy(); // Clear the loading message

      if (response.error) {
        messageApi.open({
          type: 'error',
          content: response.error,
        });
        setDisabled(false); // Re-enable the form after processing
        return;
      }

      // If login is successful, redirect to dashboard
      messageApi.open({
        type: 'success',
        content: 'Login successful! Redirecting...',
        duration: 2,
      });

      setTimeout(() => {
        window.location.href = "/"; // Redirect to dashboard
      }, 1500);
    } catch (error) {
      messageApi.destroy(); // Clear the loading message
      messageApi.open({
        type: 'error',
        content: error.message || 'An error occurred during login.',
      });

      setDisabled(false); // Re-enable the form after processing
    }
  }

  return (
    <Form onFinish={loginAccount} disabled={formDisabled} layout="vertical" style={{ marginBottom: 16 }}>
      <Form.Item label="Email" name="email" rules={[{ required: true }]}>
        <Input size="large" />
      </Form.Item>
      <Form.Item label="Password" name="password" rules={[{ required: true }]}>
        <Input.Password size="large" />
      </Form.Item>
      <Form.Item name="rememberMe" valuePropName="checked" initialValue={false}>
        <Checkbox>Remember me</Checkbox>
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" block size="large">
          Login
        </Button>
      </Form.Item>
    </Form>
  )
}

function SignUp() {
  const [formDisabled, setDisabled] = useState(false);
  const [inputPassword, setInputPassword] = useState(false);
  const messageApi = useContext(MessageApiContext);

  const signUpAccount = async (values) => {
    setDisabled(true); // Disable the form to prevent multiple submissions
    messageApi.open({
      type: 'loading',
      content: 'Signing up...',
      duration: 0,
    });
    try {
      // Send the signup request
      const response = await signUpReq(values);

      // Handle the response
      messageApi.destroy(); // Clear the loading message

      messageApi.open({
        type: response.error ? 'error' : 'success',
        content: response.error ? response.error : 'Account created successfully! Please log in.',
      });
    } catch (error) {
      messageApi.destroy(); // Clear the loading message
      messageApi.open({
        type: 'error',
        content: error.message || 'An error occurred during signup.',
      });
    }

    setDisabled(false); // Re-enable the form after processing
  }

  // Sign up logic here
  return (
    <Form disabled={formDisabled} method='POST' onFinish={signUpAccount} layout="vertical" style={{ marginBottom: 16 }}>
      <Form.Item className={`${inputPassword ? "hidden" : ""}`} label="Name" name="name" rules={[{ required: true }]}>
        <Input size="large" />
      </Form.Item>
      <Form.Item className={`${inputPassword ? "hidden" : ""}`} label="Email" name="email" rules={[{ required: true }]}>
        <Input size="large" />
      </Form.Item>
      <Form.Item className={`${inputPassword ? "" : "hidden"}`} label="Password" name="password" rules={[{ required: true }]}>
        <Input.Password size="large" />
      </Form.Item>
      <Form.Item className={`${inputPassword ? "" : "hidden"}`} label="Confirm Password" name="confirmPassword" rules={[{ required: true }]}>
        <Input.Password size="large" />
      </Form.Item>
      <Form.Item>
        {inputPassword ? (
          <div className="flex">
            <Button type="text" className="prev_button" onClick={() => setInputPassword(false)}>
              <LeftCircleOutlined className="prev_icon" /> Back
            </Button>
            <Button type="primary" htmlType="submit" block size="large">
              Signup
            </Button>
          </div>
        ) : (
          <Button type="primary" onClick={() => setInputPassword(true)} block size="large">
            Next
          </Button>
        )}
      </Form.Item>
    </Form>
  )
}

function LoginComponentHeader({ status }) {
  return (
    <div className="login_header">
      <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/jenkins/jenkins-original.svg" alt="Logo" className="logo" />
      <h2>
        {status === "signup" ? "Join PreNumbers" : "Welcome Back to PreNumbers"}
      </h2>
      <p style={{ color: "#888", margin: "8px 0 0" }}>
        {status === "signup" ? "Sign up to get started" : "Login to your account"}
      </p>
    </div>
  )
}

function LoginComponentBody({ status }) {
  const [messageApi, contextHolder] = message.useMessage();

  return (
    <MessageApiContext.Provider value={messageApi}>
      {contextHolder}
      <div>
        {status === "signup" ? (
          <div></div>
          //<SignUp messageApi={messageApi} />
        ) : (
          <Login messageApi={messageApi} />
        )}
        {/*
        <div style={{ textAlign: "center", margin: "16px 0 8px", color: "#aaa" }}>
          <span>or continue with</span>
        </div>
        <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 12, marginBottom: 16 }}>
          <ContinueWithButton
            imgSrc="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/google/google-original.svg"
            text="Google"
            onClick={() => { window.location.href = "/api/auth/google"; }}
          />
        </div>
        */}
      </div>
    </MessageApiContext.Provider>
  )
}

function ContinueWithButton({ imgSrc, text, onClick }) {
  return (
    <Button
      icon={
        <img
          src={imgSrc}
          alt={text}
          style={{ width: 20, height: 20, marginRight: 8 }}
        />
      }
      onClick={onClick}
      className="continue_with_button"
      size="large"
      block
    >
      {text}
    </Button>
  )
}

function LoginComponent() {
  const [data, setData] = useState("login");

  return (
    <Card className="login_card">
      <LoginComponentHeader status={data} />
      {/*<div className="login_toggle">
        <Space.Compact>
          <Button
            type={data === "signup" ? "default" : "primary"}
            onClick={() => setData("login")}
            className="login_button"
          >
            Login
          </Button>
          <Button
            type={data === "signup" ? "primary" : "default"}
            onClick={() => setData("signup")}
            className="login_button"
          >
            Signup
          </Button>
        </Space.Compact>
      </div>
      */}
      <LoginComponentBody status={data} />
      <div className="login_footer">
        <p>
          By continuing, you agree to our <a href="/">Terms of Service</a> and <a href="/">Privacy Policy</a>.
        </p>
      </div>
    </Card>
  );
}

function CarouselComponent() {
  return (
    <ConfigProvider theme={{
      components: {
        Carousel: {
          dotWidth: 100,
          dotHeight: 4,
          dotActiveWidth: 100,
          dotGap: 8,
          dotOffset: 20,
          arrowSize: 24,
          arrowOffset: 20,
        },
      },
    }}>
      <Carousel arrows autoplaySpeed={2500} dotPosition="top" autoplay={{ dotDuration: true }} className="prenumbers_info_carousel">
        <div className="info_slide">
          <img src="https://www.geckoboard.com/uploads/Sales-YTD-dashboard-example-1efebb.png" alt="Financial Builder" />
          <div className="info_text">
            <h2>&#x1F528;Financial Builder</h2>
            <ul>
              <li>Build your financial future with PreNumbers</li>
              <li>Track your expenses, income, and savings</li>
              <li>Visualize your financial data with intuitive dashboards</li>
            </ul>
          </div>
        </div>
        <div className="info_slide">
          <img src="https://www.infocaptor.com/img/affiliate_purchasing_kpi_dashboard_blue.png" alt="Critical Financial Insight" />
          <div className="info_text">
            <h2>&#x1F4CA; Critical Financial Insight</h2>
            <ul>
              <li>Gain critical insights into your financial health</li>
              <li>Analyze your spending patterns and investment performance</li>
              <li>Make informed decisions with real-time data</li>
            </ul>
          </div>
        </div>
        <div className="info_slide">
          <img src="https://www.slideteam.net/wp/wp-content/uploads/2024/02/Price-Optimization-Dashboard-3.png" alt="Premium Strategic Business Building" />
          <div className="info_text">
            <h2>&#x1F4B8; Premium Strategic Business Building</h2>
            <ul>
              <li>Leverage data-driven insights to optimize your business strategy.</li>
              <li>Collaborate with your team in real-time to drive innovation.</li>
              <li>Access powerful tools to streamline your financial operations.</li>
            </ul>
          </div>
        </div>
      </Carousel>
    </ConfigProvider>
  )
}

function LoginPage() {
  return (
    <div className="login_page">
      <div className="login_and_info_container">
        <div className="login_container">
          <div className="go_back">
            <Link to="/">
              <Button type="text" className="go_back_button">
                <LeftOutlined className="go_back_icon" style={{ fontSize: '16px', color: '#1890ff' }} />
                Learn More
              </Button>
            </Link>
          </div>
          <LoginComponent />
        </div>
        <div className="prenumbers_info_container">
          <CarouselComponent />
        </div>
      </div>
    </div>
  );
}

export default LoginPage;